import Tool from '@recogito/annotorious/src/tools/Tool';
import RubberbandFreehand from 'components/ImageViewer/annotorious/tools/freehand/rubberbandFreehand';
import EditableFreehand from 'components/ImageViewer/annotorious/tools/freehand/editableFreehand';
import { isFreehandAnnotation } from 'components/ImageViewer/annotorious/tools/freehand/freehandUtils';

/**
 * Pencil tool: draw a freehand stroke by dragging. Registered on the
 * Annotorious instance with `anno.addDrawingTool(...)`.
 */
export default class RubberbandFreehandTool extends Tool {
  constructor(g, config, env) {
    super(g, config, env);

    this.rubberband = null;
  }

  startDrawing = (x, y) => {
    this.attachListeners({
      mouseMove: this.onMouseMove,
      mouseUp: this.onMouseUp,
    });

    this.rubberband = new RubberbandFreehand(
      x,
      y,
      this.g,
      this.config,
      this.env,
    );
  };

  stop = () => {
    if (this.rubberband) {
      this.rubberband.destroy();
      this.rubberband = null;
    }
  };

  onMouseMove = (x, y) => {
    const { naturalWidth, naturalHeight } = this.env.image;
    const constrainX = Math.min(Math.max(x, 0), naturalWidth);
    const constrainY = Math.min(Math.max(y, 0), naturalHeight);

    this.rubberband.addPoint(constrainX, constrainY);
  };

  onMouseUp = () => {
    this.detachListeners();
    this.started = false;

    const { rubberband } = this;
    this.rubberband = null;

    if (!rubberband) {
      return;
    }

    const points = rubberband.getPoints();

    if (points.length >= 3) {
      const { element } = rubberband;
      element.annotation = rubberband.toSelection();

      this.emit('complete', element);
    } else {
      this.emit('cancel');
    }

    rubberband.destroy();
  };

  get isDrawing() {
    return this.rubberband != null;
  }

  createEditableShape = (annotation, formatters) =>
    new EditableFreehand(
      annotation,
      this.g,
      { ...this.config, formatters },
      this.env,
    );
}

RubberbandFreehandTool.identifier = 'freehand';

RubberbandFreehandTool.supports = (annotation) =>
  isFreehandAnnotation(annotation);
